import { BUYER_DATA } from "../constants/action-types";

export const uploadBuyerData = (result) => ({
    type: BUYER_DATA.UPLOAD.START,
    payload: { url: "/api/v3.0/vetl/buyer-data/upload", body: JSON.stringify(result) },
});

export const resetUploadJob = () => ({ type: BUYER_DATA.JOB.RESET });

export const startBuyerDataUploadJobPolling = (payload) => ({ type: BUYER_DATA.JOB.POLL.START, payload });

export const fetchBuyerDataUploadJob = (jobId: string, pipelineId: string) => ({
    type: BUYER_DATA.JOB.FETCH.START,
    payload: { url: "/api/v3.0/vetl/job", body: { jobId, pipelineId } },
});
